import { BLOG_AUTHOR_PERSON } from '../../../blog/blog-jsonld';
import { BASE_URL } from '../../../sitemap-pages';

/**
 * Full JSON-LD schema array for /blog: a single Blog node naming the site
 * and its author.
 *
 * Previously lived inline in app.routes.ts's static route data, which also
 * eagerly imported blog-jsonld.ts (already loaded lazily by blog-post and
 * blog-post-card) just for BLOG_AUTHOR_PERSON. Moved here 2026-09-14 so
 * it's set at runtime via SEOService — see BlogIndexComponent — inside
 * this route's own lazy chunk instead of the eager route-data bundle.
 */
export function buildBlogIndexPageSchemas(): Record<string, unknown>[] {
  return [
    {
      '@type': 'Blog',
      name: 'Russ Rodgers Bass Guitar Blog',
      url: `${BASE_URL}/blog`,
      author: BLOG_AUTHOR_PERSON,
    },
  ];
}
